import React from 'react';
import { get } from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import TableHeader from './TableHeader';
import GroupCategoryFormModal from './GroupCategoryFormModal';
import ModalDelete from './ModalDelete';
import ImageLoader from './ImageLoader';

const GroupCategoriesList = ({ groupCategories = [], total = 0 }) => {
  const inactive = (id) => {
    requestCallback(axios.put(`/${gon.currentProvider}/api/group_categories/${id}`, {
      authenticity_token: CSRF_TOKEN,
      active: false
    }))
  }

  const active = (id) => {
    requestCallback(axios.put(`/${gon.currentProvider}/api/group_categories/${id}`, {
      authenticity_token: CSRF_TOKEN,
      active: true
    }))
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Group Categories list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} groupCategories</p>
        </div>

        <div className='MainHeader__right'>
          <GroupCategoryFormModal
            klassName='MainHeader__right__a MainHeader__right__a--bright-blue'
            label='Add Group Category'
            title='Add Group Category'
            reload
          />
        </div>
      </div>

      <div className='Table Table--group-categories-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'Active',
              sortKey: 'active',
            },
            {
              label: 'Position',
              sortKey: 'rank'
            },
            {
              label: 'Icon',
            },
            {
              label: 'Name',
              sortKey: 'name'
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {groupCategories.map((groupCategory) => (
          <div className={'Table__row'} key={`groupCategory_${groupCategory.id}`}>
            <div className='Table__col'>{groupCategory.id}</div>

            <div className='Table__col'>
              {groupCategory.active ?
                <span className='Badge'>YES</span>
              :
                <span className='Badge Badge--orange'>NO</span>
              }
            </div>

            <div className='Table__col'>{groupCategory.rank}</div>

            <div className='Table__col'>
              <ImageLoader url={groupCategory.iconUrl} />
            </div>

            <div className='Table__col'>{groupCategory.name}</div>

            <div className='Table__col'>
              <div className='Table__controls'>
                <GroupCategoryFormModal
                  klassName='Table__controls__a Table__controls__a--pencil'
                  title='Edit GroupCategory'
                  groupCategory={groupCategory}
                  reload
                />
                <a
                  className={`Table__controls__a Table__controls__a--${groupCategory.active ? 'eye-close' : 'eye'}`}
                  onClick={groupCategory.active ? () => inactive(groupCategory.id) : () => active(groupCategory.id)}
                />
                <ModalDelete
                  type='group_categorie'
                  id={get(groupCategory, 'id')}
                  klassName='Table__controls__a Table__controls__a--trash'
                  reload
                  hideText
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default GroupCategoriesList
